var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#show_eye_svg__clip0_2286_13118)",
    fill: "#3A92E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.46 7.43C19.93 2.99 15.63 0 10.75 0 5.87 0 1.57 2.99.04 7.43a.82.82 0 000 .49c1.53 4.44 5.83 7.43 10.71 7.43 4.88 0 9.18-2.99 10.71-7.43a.82.82 0 000-.49zm-10.71 6.42c-4.15 0-7.81-2.47-9.2-6.17C2.94 3.97 6.6 1.5 10.75 1.5c4.15 0 7.81 2.47 9.2 6.17-1.39 3.7-5.06 6.17-9.2 6.17v.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3.08c-2.53 0-4.6 2.06-4.6 4.6a4.6 4.6 0 104.6-4.6zm0 7.69c-1.71 0-3.1-1.39-3.1-3.1 0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "show_eye_svg__clip0_2286_13118"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21.5v15.35H0z"
  })))));
}
export default SvgShowEye;